import PATHS from 'paths'

const data = {
  title: 'An award-winning direct cremation',
  subtitle:
    'A simple, respectful cremation without a service. Whether you need to arrange a funeral now, or you’re planning ahead, our Farewill Funerals specialists are here to support you.',
  imagePath: 'illustrations/cremations_hand_delivery',
  ctaLinks: [
    {
      text: 'Buy a funeral plan',
      to: PATHS.CREMATION.FUNERAL_PLANS,
    },
    {
      text: 'Arrange a funeral now',
      to: PATHS.CREMATION.DIRECT,
    },
  ],
}

export default data
